// Spend-approval summary for the whole app (SPEC §19): is the signed-in user the spend owner, who that is, and how many
// requests are waiting (the owner: all of them; anyone else: their own). Drives the nav badge, the Lead search notes and
// the "Send to PJ for approval" buttons. Refreshed every 60 s while the app is open and after any approval action.
import { useEffect, useState } from 'preact/hooks';
import { api } from './api';
import type { ApprovalsSummary } from '../../src/shared/api-team';

let current: ApprovalsSummary | null = null;
const subs = new Set<(s: ApprovalsSummary | null) => void>();
let timer: ReturnType<typeof setInterval> | null = null;
let inflight: Promise<ApprovalsSummary | null> | null = null;

export function refreshApprovals(): Promise<ApprovalsSummary | null> {
  if (inflight) return inflight;
  inflight = api.get<ApprovalsSummary>('/api/approvals/summary')
    .then((s) => { current = s; for (const f of subs) f(s); return s; })
    .catch(() => current)
    .finally(() => { inflight = null; });
  return inflight;
}

/** Forget the cached summary (sign-out). */
export function resetApprovals(): void {
  current = null;
  for (const f of subs) f(null);
}

export function useApprovals(): ApprovalsSummary | null {
  const [s, setS] = useState<ApprovalsSummary | null>(current);
  useEffect(() => {
    subs.add(setS);
    if (!current) void refreshApprovals();
    if (!timer) timer = setInterval(() => { if (subs.size) void refreshApprovals(); }, 60_000);
    return () => { subs.delete(setS); };
  }, []);
  return s;
}
